<template>
    <div class="col-md-12">
        <div class="pages__photo">
            <div class="change" v-if="selectedFile">
                <img :src="getNameOfAvatar(selectedFile.file_path)" alt="Photo" width="115">
                <a href="javascript:void(0)" class="edit" @click="$refs.imageInput.click()">
                    <svg width="16" height="16" class="icon">
                        <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                    </svg>
                </a>
            </div>
            <a
                href="javascript:void(0)"
                class="upload"
                @click="$refs.imageInput.click()"
                v-else
            >
                <img src="/img/svg/photo.svg" alt="" width="43">
                <span>Upload Photo</span>
                <small>Max 10 MB in .jpg/.png format</small>
            </a>
        </div>

            <input
                type="file"
                style="display: none"
                @change="onImageSelected"
                ref="imageInput"
                accept="image/*"
            >
        </div>

</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
    name: "SingleImageUploader",
    props: {
        propsValue: String,
        uploadHandler: Function
    },
    emits: ['update-content'],
    data() {
        return {
            selectedFile: {
                file_path: null,
                id: null,
                original_filename: null,
            },
        }
    },

   mounted() {
        if( this.propsValue) {
            this.selectedFile.file_path = this.propsValue
        }

   },

    methods: {
        onImageSelected(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    this.selectedFile = file;
                    this.uploadPhoto();
                };
                reader.readAsDataURL(file);
            }
        },
        getNameOfAvatar(photo) {
            return photo ? `/uploads/${photo}` : "/img/demo/companies-1.png";
        },
        async uploadPhoto() {
            if (this.selectedFile) {
                this.$showLoadingMessage()
                let formData = new FormData();
                formData.append('files[]', this.selectedFile);
                try {
                    const { data: response } = await this.uploadHandler(formData)
                    this.selectedFile = response[0]
                    this.$emit('update-content', this.selectedFile.file_path)
                    this.$showSuccessMessage('The image was uploaded')
                } catch (e) {
                    console.error(e);
                    this.$showErrorMessage("The image was not uploaded");
                }
            } else {
                this.$showErrorMessage("Please select photo");
            }
        },
    }
})
</script>

<style scoped>

</style>
